module.exports = __webpack_public_path__ + "static/media/profile.b7f6406e.svg";